const marked = window.marked.marked

class ChaiMarked {
    constructor() {
        this.marked = marked
        this.renderer = this.customRenderer()
        this.setMarkedOptions()
    }

    setMarkedOptions() {
        this.marked.setOptions({
            renderer: this.renderer
        });
    }

    customRenderer() {
        const renderer = new this.marked.Renderer()
        renderer.link = this.customLink
        return renderer
    }

    customLink(href) {
        return `<a class="chai-marked-link" href=${href} rel="noopener noreferrer" target="_blank">${href}</a>`
    }
}

export default ChaiMarked